"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
import { Facebook, Twitter, Linkedin, Instagram, Github } from "lucide-react";
export default function CompanyDirectory() {
  const currentYear = new Date().getFullYear();
  const products = [{
    label: "Home Inspection",
    href: "/Home-Inspection"
  }, {
    label: "Wind Mitigation",
    href: "/Wind-Mitigation-Inspection"
  }, {
    label: "4-Point Inspection",
    href: "/4-Point-Inspection"
  }, {
    label: "Condo Inspection",
    href: "/Condo-Inspection"
  }, {
    label: "Mold Testing",
    href: "/Mold-Testing"
  }, {
    label: "Pre-Listing Inspection",
    href: "/Pre-Listing-Inspection"
  }];
  const resources = [{
    label: "Miami-Dade County",
    href: "/Miami-Home-Inspector"
  }, {
    label: "Kendall",
    href: "/Kendall-Home-Inspector"
  }, {
    label: "Homestead",
    href: "/Homestead-Home-Inspector"
  }, {
    label: "Florida Keys",
    href: "/Florida-Keys-Home-Inspector"
  }, {
    label: "Broward County",
    href: "/Broward-County-Home-Inspector"
  }];
  const company = [{
    label: "Home",
    href: "/HomePage"
  }, {
    label: "Our Services",
    href: "#"
  }, {
    label: "About Us",
    href: "#"
  }, {
    label: "Schedule Now",
    href: "#"
  }, {
    label: "Contact Us",
    href: "#"
  }];
  const socialLinks = [{
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "#",
    label: "LinkedIn"
  }, {
    icon: Facebook,
    href: "#",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Github,
    href: "#",
    label: "GitHub"
  }];
  return <section id="footer" className="dark bg-secondary text-foreground border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 py-16 lg:py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8">
          {}
          <div className="lg:col-span-1 flex flex-col gap-6">
            <Link to="/HomePage" className="block w-fit">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1579221/img/connects_pro_logo.png" alt="Trusted Inspections" className="h-8 w-auto object-contain brightness-0 invert" />
            </Link>
            <p className="text-sm text-white/60 leading-relaxed">
              Trusted Inspections provides professional residential inspection services for home buyers, sellers, and insurance requirements across South Florida, ensuring clarity and peace of mind for every property.
            </p>
            <div className="flex flex-col gap-1 text-sm text-white/60">
              <Link to="tel:786-382-6895" className="hover:text-primary transition-colors w-fit">
                786-382-6895
              </Link>
              <Link to="mailto:info@trusted-fl.com" className="hover:text-primary transition-colors w-fit">
                info@trusted-fl.com
              </Link>
            </div>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => <Link key={i} to={social.href} className="text-white/60 hover:text-primary hover:scale-110 transition-all duration-300" aria-label={social.label} data-index={i}>
                  <social.icon className="size-5" />
                </Link>)}
            </div>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Services</h3>
            <ul className="flex flex-col gap-3">
              {products.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Locations</h3>
            <ul className="flex flex-col gap-3">
              {resources.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div className="flex flex-col gap-6">
            <h3 className="font-bold text-white uppercase tracking-widest text-xs">Quick Links</h3>
            <ul className="flex flex-col gap-3">
              {company.map((item, i) => <li key={i} data-index={i}>
                  <Link to={item.href} className="text-sm text-white/60 hover:text-white transition-colors duration-200">
                    {item.label}
                  </Link>
                </li>)}
            </ul>
          </div>
        </div>

        <Separator className="my-12 bg-white/10" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-white/40">
          <p>&copy; {currentYear} Trusted Inspections. FL License #HI11452. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-white transition-colors duration-200">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-white transition-colors duration-200">
              Terms of Service
            </Link>
            <Link to="#" className="hover:text-white transition-colors duration-200">
              Cookie Settings
            </Link>
          </div>
        </div>
      </div>
    </section>;
}